
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

import GreenButton from './GreenButton.vue'
import RedButton from './RedButton.vue'
import CardTitle from './CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,

  },
})
export default class ConfirmationDialog extends Vue {

@Prop(Function) public readonly validateFunction!: () => void
@Prop() private titleText!: string
@Prop() private color!: string
@Prop() private icon!: string
@Prop() private iconColor!: string
@Prop() private buttonText!: string
@Prop() private dialogText!: string
@Prop() private extraClass!: string
@Prop() private pendingStatus?: boolean
@Prop() private itemName?: string
@Prop() private buttonDisabled?: boolean
@Prop() private dialogHaveToBeClosed?: boolean

private confirmDialog: boolean = false

public mounted() {
}

public showDialog () {
  this.confirmDialog = true
}

public save() {
  if (this.dialogHaveToBeClosed === true) {
    this.confirmDialog = false
  }
  this.validateFunction()
}

private get hasIcon() {
  return this.icon !== null && this.icon !== undefined
}

private get hasBtnText() {
  return this.buttonText !== null && this.buttonText !== undefined
}

private cancel() {
  this.confirmDialog = false
}
}
